(function(root, unasigned) {
	root.md.diagnosis = root.md.diagnosis || {};
	var ns = root.md.diagnosis.diagnosis = root.md.diagnosis.diagnosis || {};

	var display;
	var validation;
	var isPersonal;
	var $section;

	$(function() {
		init();
	});


	function init(){
		isPersonal = $("body").hasClass("js-diagnosis_personal");
		$section = $(".story-section");
		display = new ns.Display($section);
		validation = new ns.Validation($section);

		display.init();

		setEvent();

		initSectionDisplay();
	}


	function setEvent(){
		setKeyEvent();
		setOnSubmit();

		var $target = $section.find(".js-story-input, .js-story-select");
		$target.each(function(index,element){
			var tag = validation.checkTag(element);
			if (tag.isInput) setInputEvent(index);
			if (tag.isSelect) setSelectEvent(index);
		});
	}
	function setKeyEvent(){
		var $target = $section.find(".js-story-input, .js-story-select");
		$target.on("keydown",disableEnterKey);
		$target.last().on("focus",function(){
			$target.off("keydown",disableEnterKey);
		});
		function disableEnterKey(evt){
			if (evt.keyCode === 13) return false;
		}
	}
	function setInputEvent(index){
		var SHOW_HINT_DELAY = 100;
		var $target = $section.eq(index).find(".js-story-input");
		$target.on("focus", onFocus);
		$target.on("blur", onBlur);
		$target.on("input", onInput);

		function onFocus(){
			display.focusSection(index);
			setTimeout(function(){
				if (display.isLatestSection(index)) {
					display.showHint(index);
				}
			}, SHOW_HINT_DELAY);
		}
		function onBlur(){
			// 先頭0入力の対策
			$target.val(parseInt($target.val(), 10));
			display.blurSection(index);
		}
		function onInput() {
			validateHelper(index, $target.val());
		}
	}
	function setSelectEvent(index){
		var SHOW_HINT_DELAY = 100;
		var isKeyDown = false;
		var $target = $section.eq(index).find(".js-story-select");
		$target.on("keydown", onKeyDown);
		$target.on("change", onChange);
		$target.on("focus", onFocus);
		$target.on("blur", onBlur);

		function onChange(){
			var val = $target.val();
			var result = validation.validateSelect(index, val);
			if (result.isValid) controlSectionDisplay(index, isKeyDown);
		}
		function onFocus(){
			removeBlankOption($target);
			display.focusSection(index);
			setTimeout(function(){
				if (display.isLatestSection(index)) {
					display.showHint(index);
				}
			}, SHOW_HINT_DELAY);
		}
		function onBlur(){
			display.blurSection(index);
		}
		function onKeyDown(evt){
			if (evt.keyCode === 37 || // ←
				evt.keyCode === 38 || // ↑
				evt.keyCode === 39 || // →
				evt.keyCode === 40) { // ↓

				isKeyDown = true;
				setTimeout(function(){
					isKeyDown = false;
				},500);
			}
		}
	}
	function setOnSubmit(){
		$(".js-diagnosis_postForm").on("submit",function(){
			var result = validation.validateAll();
			if (result.isValid) return true;

			goToErrorSection(result.invalidIndex, result.resultFirst.errorid);

			return false;
		});
	}
	function goToErrorSection(index, errorid){
		var $target = $section.eq(index);
		scrollToTarget($target, function(){
			$target.find(".js-story-input, .js-story-select").focus();
			display.showError(index, errorid);
		});
	}
	function scrollToTarget($target, callback){
		var SCROLL_BUFFER = 100;
		var offsetTop = $target.offset().top;
		$("html, body").animate({
			scrollTop: offsetTop - SCROLL_BUFFER,
		}, callback);
	}
	function removeBlankOption($target){
		$target.find("option").each(function(index, val){
			// if (!val.value) $(val).remove();
			if (!val.value) $(val).hide();
		});
	}

	function initSectionDisplay(){
		var result = checkForm(0);
		if (result.isEntered) {
			var val = $section.eq(0).find(".js-story-input, .js-story-select").val();
			validateHelper(0, val);
		}

		var emptyIndex = checkEmptyForm();
		$section.eq(emptyIndex).find(".js-story-input, .js-story-select").focus(); // 最初の空欄にfocus
	}
	function controlSectionDisplay(index, noFocus){
		var hideSectionLength = validation.checkRelatedSection(index) || 0;
		if (hideSectionLength) { // 非表示にすべきセクションがあればhide
			for (var i=1; i<=hideSectionLength; ++i) {
				display.hideSection(index + i);
			}
		} else { // 非表示にすべきセクションがなければ次のセクションを表示
			var nextIndex = index + 1;
			showSection(nextIndex, noFocus);

			var result = checkForm(nextIndex);
			if (result && result.isEntered) { // 表示したフォームが埋まってたら次へ（ループ）
				controlSectionDisplay(nextIndex);
			}
		}
		var isLastSection = (index === $section.length - 1 - hideSectionLength);
		var indexStartInvestment = 3;
		var erroridOverSavings = 3;

		var validateResult = validation.validateAll(); // 全部validateかける
        // indexStartInvestmentのvalidationのみsetInputEvent()のvalidateHelper()を通らないため、ここでshowError()/hideError()を実行する
        if (validateResult.resultList[indexStartInvestment].errorid===erroridOverSavings) {
            display.showError(indexStartInvestment,erroridOverSavings);
        }
        else {
            display.hideError(indexStartInvestment);
		}
		if (!validateResult.isValid) {
			display.disableSubmitBtn();
			if (validateResult.invalidIndex >= index) return; // 自分よりも前にinvalidがなければreturn
			$(validateResult.invalidIndexList).each(function(_,val){
				if (val >= index) return false;
				display.showError(val, validateResult.resultList[val].errorid);
			});
			// 最後ならerror箇所へ（blurで）
			if ( isLastSection ) {
				$section.eq(index).find(".js-story-input, .js-story-select").one("blur", function(){
					goToErrorSection(validateResult.invalidIndex, validateResult.resultFirst.errorid);
				});
			}
		}
		// validation通って && 最後ならsubmitボタン表示
		else if ( isLastSection ) {
			display.hideFocusBg();
			display.enableSubmitBtn();
			display.showSubmitBtn();
		}

		// サーバ送信用に実際の金額値をセット
		$("#income_value").val(Number($('#income').val()) * 10000);
		$("#savings_value").val(Number($('#savings').val()) * 10000);
		$("#startInvestment_value").val(Number($('#startInvestment').val()) * 10000);
		$("#reserveAmount_value").val(Number($('#reserveAmount').val()) * 10000);

		function showSection(index, noFocus){
			display.showFocusBg();
			display.showSection(index);
			// display.showSection(index).on("shown.bs.collapse",function(evt){
			// 	if (!noFocus) $(evt.target).find(".js-story-input, .js-story-select").focus();
			display.Evt.one("showend",function(evt, target){
			});
		}
		function showNextSection(index, noFocus){
			showSection(index+1, noFocus);
		}
	}
	function validateHelper(index, value){
		var result = validation.validate(index, value);
		if (result.isValid) {
			display.hideError(index);
			controlSectionDisplay(index);
		} else {
			display.hideError(index, result.errorid);
			display.showError(index, result.errorid);
			display.disableSubmitBtn();
		}
		return result.isValid;
	}
	function checkForm(index){
		var $target = $section.eq(index).find(".js-story-input, .js-story-select");
		if (!$target.get(0)) return false;
		var value = $target.val();
		var isEntered = (value !== "");
		return {
			$target:   $target,
			value:     value,
			isEntered: isEntered,
		};
	}
	function checkEmptyForm(){
		var $target = $section.find(".js-story-input, .js-story-select");
		var targetLength = $target.length;
		var shouldShow = false;
		var emptyIndex = 0;
		$target.each(function(index,val){
			var isEntered = (val.value !== "");
			if (!isEntered) {
				emptyIndex = index;
				return false;
			}
		});
		return emptyIndex;
	}

})(this);
